import { toast } from 'react-toastify';
import TrackerToastContent from './TrackerToastContent';

const TRACKER_TOAST_ID = (id) => `tracker-persistent-${id}`;
const TRACKER_TOAST_STYLE = {
  background: '#26292C',
  color: '#f6f7eb',
  border: '1px solid #393e41',
  borderRadius: '6px',
};

const ROLL_TOAST_DEFAULT_BG = '#1a1a1a';

const showDisplayRollToast = (roll, displayText) => {
  const username = String(roll?.username || 'Player').trim();
  const accent = roll?.theme?.accent ?? null;
  const background = roll?.theme?.background ?? null;
  const message = `${username}: ${displayText}`;
  const options =
    accent || background
      ? {
          style: {
            background: background || ROLL_TOAST_DEFAULT_BG,
            color: '#fff',
            border: accent ? `2px solid ${accent}` : undefined,
          },
        }
      : undefined;

  toast(message, options);
};

const syncDisplayTrackerToasts = (trackers) => {
  trackers.forEach((tracker) => {
    const toastId = TRACKER_TOAST_ID(tracker.id);
    if (tracker.visible && !toast.isActive(toastId)) {
      toast(<TrackerToastContent tracker={tracker} variant='display' />, {
        toastId,
        autoClose: false,
        closeButton: false,
        closeOnClick: false,
        draggable: false,
        style: TRACKER_TOAST_STYLE,
      });
    } else if (!tracker.visible) {
      toast.dismiss(toastId);
    }
  });
};

const applyDisplayTrackerToastAction = ({ action, tracker, changeInfo }) => {
  if (!tracker || !tracker.id) return;
  const toastId = TRACKER_TOAST_ID(tracker.id);
  if (action === 'dismiss') {
    toast.dismiss(toastId);
  } else if (action === 'show') {
    if (!toast.isActive(toastId)) {
      toast(<TrackerToastContent tracker={tracker} variant='display' />, {
        toastId,
        autoClose: false,
        closeButton: false,
        closeOnClick: false,
        draggable: false,
        style: TRACKER_TOAST_STYLE,
      });
    }
  } else if (action === 'update') {
    if (!tracker.visible) return;
    const content = (
      <TrackerToastContent tracker={tracker} changeInfo={changeInfo} variant='display' />
    );
    if (toast.isActive(toastId)) {
      toast.update(toastId, { render: content });
    } else {
      toast(content, {
        toastId,
        autoClose: false,
        closeButton: false,
        closeOnClick: false,
        draggable: false,
        style: TRACKER_TOAST_STYLE,
      });
    }
  }
};

const WorldMapOverlay = ({ mapOverlayData }) => {
  if (!mapOverlayData.active || !mapOverlayData.worldMap) return null;

  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
        zIndex: 2000,
      }}
    >
      {(mapOverlayData.worldMap.layers || [])
        .filter((layer) => layer.visible !== false)
        .slice()
        .sort((a, b) => (a.z || 0) - (b.z || 0))
        .map((layer) => (
          <img
            key={layer.id}
            src={layer.imageUrl}
            alt={layer.name || 'Map layer'}
            draggable={false}
            style={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              zIndex: layer.z || 1,
              transform: `translate(${mapOverlayData.view.panX}px, ${mapOverlayData.view.panY}px) scale(${mapOverlayData.view.zoom})`,
              transformOrigin: 'center center',
            }}
          />
        ))}
    </div>
  );
};

export {
  showDisplayRollToast,
  syncDisplayTrackerToasts,
  applyDisplayTrackerToastAction,
  WorldMapOverlay,
};
